import { API_PATHS } from "../API_PATHS";
import { request } from "../utils";

export const getParquetFileLink = (
  organizationId: number,
  tenantId: number,
  entityIdentifier: string
): Promise<any> => {
  return request({
    method: "GET",
    // eslint-disable-next-line max-len
    url: `${API_PATHS.BASE_URLS.API_URL}${API_PATHS.EXPORT.GET_PARQUET_FILE_LINK(organizationId, tenantId, entityIdentifier)}`,
  });
};
